import type { FaireProductEntity } from "../../entity_types/product";

export const p_g7jzm6sy9w: FaireProductEntity = {
  token: "p_g7jzm6sy9w",
  type: "product",
  name: "18K Gold Plated Knot Earrings - Minimalist Statement Jewelry",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/aba53abfe7db624db02d25e63e74946983a683ec6ec8aac5dc3b5aedc1818680.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0074c900c33b663561fd9f268c55143c7331d4e4d8e4f98e6f199d8dc9e34c27.jpeg",
    "https://cdn.faire.com/fastly/a827d804de36e61ad71884e5376aa5a3750e0f7e91223f9d7374cad2bea8dced.jpeg",
    "https://cdn.faire.com/fastly/399a396bc0456f974bd0e751169c478b6b92110c95052bd7500e8b2217e7eab2.jpeg",
    "https://cdn.faire.com/fastly/19b440e78489e3ff5f03d978b73db5a9ebd4b435233ffed1755474db49bb0b5f.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "Size: 1.4cm*1.8cm\nMaterial: Brass plated with 18K gold, S925 silver needles plated with 18K gold\n\nTimeless Knot Design: Features a sophisticated interlocking knot silhouette, symbolizing strength and connection.\n\nHigh-Shine Finish: Expertly plated in 18K gold for a luxurious, long-lasting luster that resists tarnishing.\n\nEveryday Elegance: Lightweight and hypoallergenic, these earrings are designed for comfortable all-day wear from the office to dinner.",
  tags: [],
  msrpDollars: 24.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:34.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
